export default class HttpMethodNotSupportedError extends Error {
    constructor(method) {
        super(`The HTTP method ${method} is not supported.`);
    }
}
